var hash = require("object-hash");

exports.sha1 = (x) => hash(x);
